<template>
  <div class="main-view">
    <el-form ref="elFormDom" inline :model="table.params" :size="subUnitSize">
      <el-form-item label="年份筛选" prop="create_year">
        <el-date-picker
          v-model="table.params.create_year"
          type="year"
          placeholder="选择年"
          format="yyyy年"
          value-format="yyyy"
        >
        </el-date-picker>
        <span
          :class="table.params.create_month == v ? 'monthV acColor' : 'monthV'"
          v-for="v in this.monthObj"
          :key="v"
          @click="selMonth(v)"
          >{{ v }}月</span
        >
      </el-form-item>
    </el-form>
    <div class="tableType">
      <el-radio-group v-model="table.params.status" @change="handleTabs">
        <el-radio-button :label="1"
          >待确认({{ statusTotal.to_review_count }})</el-radio-button
        >
        <el-radio-button :label="3"
          >待定稿({{ statusTotal.to_confirm_count }})</el-radio-button
        >
        <el-radio-button :label="4"
          >待发放({{ statusTotal.stay_out_count }})</el-radio-button
        >
        <el-radio-button :label="5"
          >已发放({{ statusTotal.issued_count }})</el-radio-button
        >
      </el-radio-group>
    </div>
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" :size="subUnitSize">
        <el-form-item label="用工单位" prop="company_id">
          <el-select
            v-model="table.params.company_id"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in companyOpt"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年份筛选" prop="year">
          <el-date-picker
            v-model="table.params.year"
            type="year"
            placeholder="选择年"
            format="yyyy年"
            value-format="yyyy"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="月份筛选" prop="month">
          <el-date-picker
            v-model="table.params.month"
            type="month"
            placeholder="选择月"
            format="MM月"
            value-format="MM"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          v-if="this.icId == 0"
          label="开票单位"
          prop="invoice_company_id"
        >
          <el-select
            v-model="table.params.invoice_company_id"
            placeholder="请选择"
            clearable
            filterable
            @change="getTable"
          >
            <el-option
              v-for="item in invoiceCompanyOpt"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工资发放日期" prop="settlement_day">
          <el-select
            v-model="table.params.settlement_day"
            placeholder="请选择"
            clearable
            filterable
            @change="getTable"
          >
            <el-option
              v-for="item in settlement_day_options"
              :key="item"
              :label="item + '号'"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否垫付" prop="prepayment_type">
          <el-select
            v-model="table.params.prepayment_type"
            placeholder="请选择"
            clearable
            filterable
            @change="getTable"
          >
            <el-option label="需要垫付" :value="1"></el-option>
            <el-option label="回款后发" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="received_status">
          <el-select
            v-model="table.params.received_status"
            placeholder="请选择"
            filterable
            clearable
          >
            <el-option label="全部回款" :value="1"></el-option>
            <el-option label="部分回款" :value="2"></el-option>
            <el-option label="未回款" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发放日期" prop="issue_time" v-if="table.params.status == 5">
            <el-date-picker
              v-model="table.params.issue_time"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询 </el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <!-- 状态：3 待定稿 4待发放 5 已发放 -->
      <div class="btnAdd" style="display: flex; justify-content: space-between">
        <div>
          <el-button
            v-show="this.table.params.status === 1"
            :size="subUnitSize"
            type="primary"
            icon="el-icon-plus"
            @click="handleAdd"
            >新增工资表</el-button
          >
          <el-button
            v-show="this.table.params.status === 4"
            :size="subUnitSize"
            type="primary"
            @click="handleBatch"
            >批量发放</el-button
          >
          <el-button
            :size="subUnitSize"
            type="primary"
            @click="handleExportList"
            >导出列表</el-button
          >
          <el-button
            v-show="this.table.params.status === 4"
            :size="subUnitSize"
            type="primary"
            @click="handleApplyPayment"
            :disabled="applyPaymentLoading"
            :loading="applyPaymentLoading"
            >申请发放</el-button
          >
          <el-button
            v-show="
              this.table.params.status === 4 || this.table.params.status === 5
            "
            :size="subUnitSize"
            type="primary"
            @click="handlePaymentList"
            >申请记录</el-button
          >
          <el-button
            v-show="this.table.params.status === 5"
            :size="subUnitSize"
            type="primary"
            @click="handleExportTaxForm"
            >导出报税表</el-button
          >
        </div>
        <div>
          <el-button :size="subUnitSize" type="primary" @click="showEditSalary"
            >修改工资表规则</el-button
          >
        </div>
      </div>
    </div>

    <VTable
      has-pagionation
      title=""
      addText="添加"
      ref="vTableDom"
      :field="curField"
      :loading="table.loading"
      :data="table.data"
      :page="table.params.page"
      :pageSize="table.params.count"
      :total="table.total"
      :tree-props="{ children: 'children', hasChildren: 'has_child' }"
      :hasPagionation="true"
      :default-expand-all="true"
      :showSelect="true"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:settlement_day="{ row }">
        <span>{{ row.settlement_day ? row.settlement_day + "号" : "" }}</span>
      </template>
      <template v-slot:prepayment_type="{ row }">
        <span>{{ { 1: "需要垫付", 2: "回款后发" }[row.prepayment_type] }}</span>
      </template>
      <template v-slot:year="{ row }">
        <span>{{ row.year }}-{{ row.month }}</span>
      </template>
      <template v-slot:received_status="{ row }">
        <el-dropdown
          v-if="row.received_status == 3 || row.received_status == 0"
          style="margin-left: 6px"
          @command="(val) => toreceivedAmount(val, row)"
        >
          <el-button type="text">未回款</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="part">部分回款</el-dropdown-item>
            <el-dropdown-item command="all">全额回款</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          type="text"
          v-if="row.received_status == 2"
          @click="toPartReceived(row)"
          >部分回款￥{{ row.received_amount }}</el-button
        >
        <el-popover
          v-if="row.received_status == 1"
          placement="top-start"
          title=""
          trigger="hover"
          :content="`${row.received_at}已被${row.received_name}修改为全额回款`"
        >
          <el-button slot="reference" type="text">全部回款</el-button>
        </el-popover>
        <!-- <template v-else-if="row.pay_status === 0 && row.status === 1">
          <span >待确认</span>
        </template>
        <template v-else-if="row.pay_status === 3">
          <el-button type="text" @click="handleStatus(row)">未回款已垫付</el-button>
        </template>
        <template v-else>
          <p v-for="item in payStatus" :key="item.id">
            <span v-if="item.id === row.pay_status">{{item.name}}</span>
          </p>
        </template> -->
      </template>
      <template v-slot:gzb="{ row }">
        <!-- 只有分公司的待确认状态可以上传工资表，其他状态以及总部都是预览工资表(在职人数为0时禁用预览按钮) -->
        <el-button
          v-if="row.status === 1"
          type="text"
          @click="handleUpload(row)"
          >上传</el-button
        >
        <el-button
          type="text"
          @click="handlePreview(row)"
          :disabled="row.total_employees === 0 ? true : false"
          >预览</el-button
        >
      </template>
      <template v-slot:invoice_company_id="{ row }">
        <span>{{ row.invoice.name }}</span>
      </template>
      <template v-slot:action="{ row }">
        <!-- 发放状态 0 未定稿 1待发放 2 已回款已发放 3 未回款已垫付 -->
        <template v-if="table.params.status == 1">
          <el-button type="text" @click="handleUntreadList(row, '5')"
            >不发</el-button
          >
          <el-button type="text" @click="handleCheck(row)">复核</el-button>
          <el-button type="text" @click="showEdit(row)">开票</el-button>
        </template>
        <template v-if="table.params.status == 3">
          <el-button type="text" @click="handleConfirm(0, row)">驳回</el-button>
          <el-button type="text" @click="handleConfirm(1, row)">定稿</el-button>
          <el-button type="text" @click="showDetail(row)">查看</el-button>
        </template>
        <template v-if="table.params.status == 4">
          <el-popconfirm
            style="margin-left: 6px"
            title="确认发放吗？"
            @confirm="topayment(row)"
          >
            <el-button slot="reference" type="text">发放</el-button>
          </el-popconfirm>
          <el-dropdown
            style="margin-left: 6px"
            @command="(val) => daifafangHande(val, row)"
          >
            <el-button type="text">更多</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">退回</el-dropdown-item>
              <el-dropdown-item command="b">无卡</el-dropdown-item>
              <el-dropdown-item command="c">查看</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <template v-if="table.params.status == 5">
          <el-button type="text" @click="showDetail(row)">查看</el-button>
          <el-button type="text" @click="failRow(row)">失败</el-button>
        </template>
        <el-dropdown
          v-if="[1, 3, 4, 5].includes(table.params.status)"
          style="margin-left: 6px"
          @command="(val) => handleExport(val, row)"
        >
          <el-button type="text">下载</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">全部</el-dropdown-item>
            <el-dropdown-item command="k">银行本</el-dropdown-item>
            <el-dropdown-item command="b">自选</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </VTable>

    <edit ref="edit" @refresh="getTable" :companyList="companyOpt"></edit>
    <detail ref="detail"></detail>
    <!-- 驳回，定稿，发放确认 -->
    <confirm
      ref="confirm"
      :curType="curType"
      :curRow="curRow"
      @refresh="getTable"
    ></confirm>

    <untread-list ref="UntreadList"></untread-list>
    <preview ref="preview" @refresh="getTable"></preview>
    <!-- 资结算-新增工资表 -->
    <add ref="add" @refresh="getTable"></add>
    <downloadRow ref="downloadRowRef"></downloadRow>
    <salaryRule ref="salaryRuleRef"></salaryRule>
    <paymentListDialog
      ref="paymentListDialogRef"
      @refresh="getTable"
    ></paymentListDialog>
    <partReceivedDialog
      ref="partReceivedDialogRef"
      @refresh="getTable"
    ></partReceivedDialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span>
        <!-- <el-radio v-model="radioStatus" :label="1" border>已回款已发放</el-radio> -->
        <el-checkbox v-model="dialogInfo.radioStatus">已回款已发放</el-checkbox>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="statusCommit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="上传"
      :visible.sync="dialogVisibleSally"
      width="30%"
      :before-close="handleClosesally"
    >
      <div>
        <div style="margin-bottom: 10px">
          1、更新流程：下载结算表→修改薪资数据→点击上传→提交后预览检查
        </div>
        <div style="margin-bottom: 10px">
          2、注意以下数据以系统为准，不支持表格修改：单位名称、姓名、基本工资、个人或单位五险（除外补缴）、个人或单位公积金（补缴除外）、雇主责任险、应发工资、管理费、税点、开票金额、个税、垫付、实发工资以及其他员工个人和收款信息
        </div>
        <el-upload
          class="upload-demo"
          drag
          :limit="1"
          action=""
          :headers="{ token: token }"
          :file-list="fileList"
          :on-remove="removeFile"
          :multiple="false"
          :http-request="httpRequestBack"
          accept=".xls,.xlsx"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <div class="" v-if="is_withholding_performance == 1">
          <p>累计考核绩效：{{ withholding_performance_total }}元</p>
          <p>累计发放绩效：{{ withholding_performance_pay_total }}元</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleSally = false">取 消</el-button>
        <el-button type="primary" @click="uploadSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <selectCompanyApplayDialog ref="selectCompanyApplayDialogRef"></selectCompanyApplayDialog>
  </div>
</template>

<script>
import Edit from "./components/Edit.vue";
import Detail from "./components/Detail.vue";
import Confirm from "./components/Confirm.vue";
import Preview from "./components/Preview.vue";
import Add from "./components/Add.vue";
import VTable from "@/components/VTable";
import { getStorage } from "@/storage";
import { exportData } from "@/util";
import UntreadList from "./components/untreadList.vue";
import downloadRow from "./components/downloadRow.vue";
import { mapGetters } from "vuex";
import { mixinTable } from "@/mixins/table.js";
import salaryRule from "./components/salaryRule.vue";
import paymentListDialog from "./components/paymentListDialog.vue";
import partReceivedDialog from "./components/partReceivedDialog.vue";
import selectCompanyApplayDialog from "./components/selectCompanyApplayDialog.vue";
export default {
  name: "",
  mixins: [mixinTable],
  components: {
    Edit,
    Detail,
    Confirm,
    Preview,
    VTable,
    UntreadList,
    Add,
    downloadRow,
    salaryRule,
    paymentListDialog,
    partReceivedDialog,
    selectCompanyApplayDialog,
  },
  computed: {
    ...mapGetters({
      companyOpt: "companyList", // 获取企业列表
      invoiceCompanyOpt: "invoiceCompany", // 获取开票单位列表
    }),
  },
  data() {
    return {
      token: getStorage("token"),
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      field: [
        { name: "id", label: "ID", width: "80" },
        { name: "year", label: "工资月份", hidden: false },
        { name: "company_name", label: "用工单位", hidden: false },
        { name: "created_at", label: "生成时间", width: "160", hidden: false },
        { name: "total_employees", label: "在职总数/人", hidden: false },
        // { name: "extra_invoice", label: "福利费/元", hidden: false},
        { name: "total_invoice", label: "开票金额/元", hidden: false },
        { name: "total_money", label: "应发工资/元", hidden: false },
        { name: "total_salary", label: "实发工资/元", hidden: false },
        {
          name: "settlement_day",
          label: "工资发放日期",
          width: "110",
          hidden: false,
        },
        {
          name: "received_status",
          label: "回款状态",
          width: "180px",
          hidden: false,
        },
        { name: "updated_at", label: "更新时间", width: "160", hidden: false },
        { name: "gzb", label: "工资表", width: "100", hidden: false },
        {
          name: "action",
          label: "操作",
          width: "180",
          hidden: false,
          fixed: "right",
        },
      ],
      // 2为待确认显示的字段
      field2: [
        { name: "id", label: "ID", width: "80" },
        { name: "year", label: "工资月份", hidden: false },
        { name: "company_name", label: "用工单位", hidden: false },
        {
          name: "invoice_company_id",
          label: "开票单位",
          width: "200",
          hidden: false,
        },
        { name: "created_at", label: "生成时间", width: "160", hidden: false },
        { name: "total_employees", label: "在职总数/人", hidden: false },
        // { name: "extra_invoice", label: "福利费/元", hidden: false},
        { name: "total_invoice", label: "开票金额/元", hidden: false },
        { name: "total_money", label: "应发工资/元", hidden: false },
        { name: "total_salary", label: "实发工资/元", hidden: false },
        { name: "check_at", label: "确认时间", width: "160", hidden: false },
        {
          name: "settlement_day",
          label: "工资发放日期",
          width: "110",
          hidden: false,
        },
        { name: "prepayment_type", label: "是否垫付", hidden: false },
        {
          name: "received_status",
          label: "回款状态",
          width: "180px",
          hidden: false,
        },
        { name: "updated_at", label: "更新时间", width: "160", hidden: false },
        { name: "gzb", label: "工资表", width: "100", hidden: false },
        {
          name: "action",
          label: "操作",
          width: "180",
          hidden: false,
          fixed: "right",
        },
      ],
      field3: [
        { name: "id", label: "ID", width: "80" },
        { name: "year", label: "工资月份", hidden: false },
        { name: "company_name", label: "用工单位", hidden: false },
        {
          name: "invoice_company_id",
          label: "开票单位",
          width: "200",
          hidden: false,
        },
        { name: "created_at", label: "生成时间", width: "160", hidden: false },
        { name: "total_employees", label: "在职总数/人", hidden: false },
        // { name: "extra_invoice", label: "福利费/元", hidden: false},
        { name: "total_invoice", label: "开票金额/元", hidden: false },
        { name: "total_money", label: "应发工资/元", hidden: false },
        { name: "total_salary", label: "实发工资/元", hidden: false },
        { name: "confirm_at", label: "定稿时间", width: "160", hidden: false },
        {
          name: "settlement_day",
          label: "工资发放日期",
          width: "110",
          hidden: false,
        },
        { name: "prepayment_type", label: "是否垫付", hidden: false },
        {
          name: "received_status",
          label: "回款状态",
          width: "180px",
          hidden: false,
        },
        { name: "updated_at", label: "更新时间", width: "160", hidden: false },
        { name: "gzb", label: "工资表", width: "100", hidden: false },
        {
          name: "action",
          label: "操作",
          width: "150",
          hidden: false,
          fixed: "right",
        },
      ],
      field4: [
        { name: "id", label: "ID", width: "80" },
        { name: "year", label: "工资月份", hidden: false },
        { name: "company_name", label: "用工单位", hidden: false },
        {
          name: "invoice_company_id",
          label: "开票单位",
          width: "200",
          hidden: false,
        },
        { name: "created_at", label: "生成时间", width: "160", hidden: false },
        { name: "total_employees", label: "在职总数/人", hidden: false },
        // { name: "extra_invoice", label: "福利费/元", hidden: false},
        { name: "total_invoice", label: "开票金额/元", hidden: false },
        { name: "total_money", label: "应发工资/元", hidden: false },
        { name: "total_salary", label: "实发工资/元", hidden: false },
        { name: "issue_at", label: "发放时间", width: "160", hidden: false },
        {
          name: "settlement_day",
          label: "工资发放日期",
          width: "110",
          hidden: false,
        },
        { name: "prepayment_type", label: "是否垫付", hidden: false },
        {
          name: "received_status",
          label: "回款状态",
          width: "180px",
          hidden: false,
        },
        { name: "updated_at", label: "更新时间", width: "160", hidden: false },
        { name: "gzb", label: "工资表", width: "100", hidden: false },
        {
          name: "action",
          label: "操作",
          width: "150",
          hidden: false,
          fixed: "right",
        },
      ],
      monthObj: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      settlement_day_options: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
      table: {
        loading: false,
        params: {
          company_name: "",
          status: 1,
          pay_status: "",
          received_status: "",
          year: "",
          month: "",
          create_year: "", // 生成年
          create_month: "", // 生成月
          invoice_company_id: "", // 开票单位
          settlement_day: "", // 工资发放日期
          prepayment_type: "",
          issue_time:[],
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
      rowId: "",
      isDetail: false,
      selPayStatus: [
        {
          id: 2,
          name: "已回款已发放",
        },
        {
          id: 3,
          name: "未回款已垫付",
        },
      ],
      payStatus: [
        {
          id: 0,
          name: "待定稿",
        },
        {
          id: 1,
          name: "待发放 ",
        },
        {
          id: 2,
          name: "已回款已发放",
        },
        {
          id: 3,
          name: "未回款已垫付",
        },
      ],
      dialogVisible: false,
      curType: "",
      curRow: {},
      batchData: [],
      statusTotal: {
        to_review_count: "",
        to_confirm_count: "",
        stay_out_count: "",
        issued_count: "",
      },
      curField: [],
      dialogInfo: {
        radioStatus: true,
        id: "",
      },
      icId: Number(getStorage("icId")), // 登录账号的身份id（0：总公司, 2:鹰潭分公司）
      fileList: [],
      upload: {
        file_path: "",
      },
      is_withholding_performance: 0,
      is_withholding_performance: 0, // 是否有填写过考核绩效
      withholding_performance_total: 0, // 累计考核绩效
      withholding_performance_pay_total: 0, // 累计发放绩效
      dialogVisibleSally: false,
      applyPaymentLoading: false,
    };
  },
  created() {
    this.curField = this.field;
    // 默认当前年月
    this.table.params.create_year = this.$moment().format("yyyy");
    this.table.params.create_month =
      this.monthObj[this.$moment().format("MM") - 1];
    this.getTable();
  },
  methods: {
    getTable() {
      let [issue_start = '', issue_end = '' ] = this.table.params.issue_time || [];
      let params = {
        ...this.table.params,
        issue_end:this.table.params.status == 5 ? issue_end : '',
        issue_start :this.table.params.status == 5 ? issue_start : '',
      };
      this.$http.post("/admin/finance/list", params).then((res) => {
        if (res.code === 1) {
          this.statusTotal.to_review_count = res.data.to_review_count;
          this.statusTotal.to_confirm_count = res.data.to_confirm_count;
          this.statusTotal.stay_out_count = res.data.stay_out_count;
          this.statusTotal.issued_count = res.data.issued_count;

          this.table.data = res.data.list.map((i) => {
            return {
              ...i,
            };
          });
          this.table.total = res.data.total;
          this.batchData = [];
          this.$nextTick(() => {
            this.$refs.vTableDom.$refs.multipleTable.doLayout();
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 新增工资表
    handleAdd() {
      let dom = this.$refs.add;
      dom.toggle(true);
      dom = null;
    },
    showEdit(row) {
      // identify角色身份：1-结算人员；2-会计；3-出纳；
      let identify = getStorage("identify");
      if (identify != 1) {
        this.$message.error("抱歉，该账号不是结算人员");
        return;
      }
      let dom = this.$refs.edit;
      dom.toggle(true);
      if (!!row.id) {
        dom.getDetail(row);
      }
      dom = null;
    },
    // 查看
    showDetail(row) {
      let dom = this.$refs.detail;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    // 返回 type:1-无卡， 2-退回
    handleUntreadList(row, type) {
      let identify = getStorage("identify");
      // if(type == 5 && identify != 1) {
      //   this.$message.error('抱歉，该账号不是结算人员');
      //   return;
      // }
      if (type == 1 && identify != 3) {
        this.$message.error("抱歉，该账号不是出纳人员");
        return;
      }
      if (type == 2 && identify != 3) {
        this.$message.error("抱歉，该账号不是出纳人员");
        return;
      }
      let dom = this.$refs.UntreadList;
      dom.toggle(true);
      dom.getDetail(row, type);
      dom = null;
    },
    // 批量选择的数据
    handleSelectionChange(batchData) {
      this.batchData = batchData;
    },
    // 批量发放
    handleBatch() {
      if (this.batchData.length > 0) {
        this.curType = 3;
        let dom = this.$refs.confirm;
        dom.toggle(true);
        // dom.getDetail(this.batchData)
        dom.getBatchData(this.batchData);
        dom = null;
      } else {
        this.$message.warning("请选择需要批量发放的数据！");
      }
    },
    // 驳回、定稿、发放
    handleConfirm(type, row) {
      // 0:驳回、1:定稿、2:发放
      let identify = getStorage("identify");
      if ((type == 0 || type == 1) && identify != 2) {
        this.$message.error("抱歉，该账号不是会计人员");
        return;
      }
      if (type == 2 && identify != 3) {
        this.$message.error("抱歉，该账号不是出纳人员");
        return;
      }
      this.curType = type;
      this.curRow = row;
      let dom = this.$refs.confirm;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    // 导出
    handleExport(val, row) {
      if (val == "a") {
        exportData({ id: row.id }, "/admin/finance/export");
      } else if (val == "b") {
        let dom = this.$refs.downloadRowRef;
        dom.toggle(true);
        dom.getDetail(row);
      } else if (val == "k") {
        exportData({ id: row.id }, "/admin/finance/exportBanks");
      }
    },
    handleExportList() {
      let list = this.batchData;
      if (list.length > 0) {
        let _param = {
          ...this.table.params,
          ids: list.map((item) => item.id).toString(),
        };
        delete _param.page;
        delete _param.count;
        exportData(_param, "/admin/finance/exportSettlement");
      } else {
        let _param = {
          ...this.table.params,
        };
        delete _param.page;
        delete _param.count;
        exportData(_param, "/admin/finance/exportSettlement");
      }
    },
    handleExportTaxForm() {
      let list = this.batchData;
      if (list.length > 0) {
        let list2 = list.map((item) => item.invoice_company_id);
        let isSame = list2.every((item) => item === list2[0]);
        if (!isSame) {
          this.$message.error("所选数据不属于同一开票单位，请重新选择！");
          return;
        } else {
          let obj = {
            ids: list.map((item) => item.id).join(","),
          };
          exportData(obj, "/admin/finance/exportTaxForm");
        }
      } else {
        this.$message.error("请选择需要导出的数据！");
      }
    },
    handleTabs(value) {
      this.table.params.pay_status = "";
      if (value === 1) {
        this.curField = this.field;
      } else if (value === 3) {
        this.curField = this.field2;
      } else if (value === 4) {
        this.curField = this.field3;
      } else if (value === 5) {
        this.curField = this.field4;
      }
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    handleStatus(row) {
      let identify = getStorage("identify");
      if (identify != 3) {
        this.$message.error("抱歉，该账号不是出纳人员");
        return;
      }
      this.dialogVisible = true;
      this.dialogInfo.id = row.id;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 已发放列表下的状态为“未回款已垫付”时可以更改为“已回款已发放”
    statusCommit() {
      let _params = {
        pay_status: 2,
        id: this.dialogInfo.id,
      };
      this.$http.post("/admin/finance/pay", _params).then((res) => {
        if (res.code === 1) {
          this.dialogVisible = false;
          this.table.params.status = 5; // 刷新状态5：已发放的数据表格
          this.getTable();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 预览
    handlePreview(row) {
      let dom = this.$refs.preview;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    // 退回
    handleRetreat(row) {
      let identify = getStorage("identify");
      if (identify != 3) {
        this.$message.error("抱歉，该账号不是出纳人员");
        return;
      }
      this.$confirm("确认退回吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/admin/finance/rollback", { id: row.id })
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("操作成功！");
                this.getTable();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    selMonth(v) {
      this.table.params.create_month = v;
      this.getTable();
    },
    // 复核
    handleCheck(row) {
      // let identify = getStorage('identify');
      // if(identify != 1){
      //   this.$message.error('抱歉，该账号不是结算人员');
      //   return;
      // }
      this.$confirm("请确认操作？", "提示", {
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            this.$http
              .post("/admin/finance/recheck", { id: row.id })
              .then((res) => {
                if (res.code === 1) {
                  this.$message.success("操作成功！");
                  this.getTable();
                } else {
                  this.$message.error(res.msg);
                }
              });
            done();
          } else {
            done();
          }
        },
      });
    },
    handleUpload(row) {
      this.upload = row;
      this.fileList = [];
      this.is_withholding_performance = 0;
      this.dialogVisibleSally = true;
    },
    handleClosesally() {
      this.dialogVisibleSally = false;
    },
    removeFile() {
      this.fileList = [];
    },
    uploadSubmit() {
      let _params = {
        company_id: this.upload.company_id,
        year: this.upload.year,
        month: this.upload.month,
        file_path: this.upload.file_path,
      };
      this.$http
        .post("/admin/finance/uploadStatements", _params)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("上传成功");
            this.dialogVisibleSally = false;
            this.getTable(); // 刷新列表
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    httpRequestBack(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      formData.append("company_id", this.upload.company_id);
      formData.append("year", this.upload.year);
      formData.append("month", this.upload.month);
      this.$http
        .post("/admin/finance/uploadStatementsFile", {
          formData,
          type: "upload",
          obj: {
            company_id: this.upload.company_id,
            year: this.upload.year,
            month: this.upload.month,
          },
        })
        .then((res) => {
          if (res.code === 1) {
            this.is_withholding_performance =
              res.data.is_withholding_performance;
            this.withholding_performance_total =
              res.data.withholding_performance_total;
            this.withholding_performance_pay_total =
              res.data.withholding_performance_pay_total;
            this.upload.file_path = res.data.file_path;
            let str = {
              url: res.data.file_path,
              name: file.file.name,
            };
            this.fileList.push(str);
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    showEditSalary() {
      let dom = this.$refs.salaryRuleRef;
      dom.toggle(true);
      dom = null;
    },
    daifafangHande(val, row) {
      if (val == "a") {
        this.handleRetreat(row);
      } else if (val == "b") {
        this.handleUntreadList(row, "1");
      } else if (val == "c") {
        this.showDetail(row);
      } else {
      }
    },
    handleApplyPayment() {
      let dom  = this.$refs.selectCompanyApplayDialogRef;
      dom.toggle(true);
      dom.getDetail({
        create_year: this.table.params.create_year,
        create_month: this.table.params.create_month,
      });
      dom = null;
    },
    handlePaymentList() {
      let dom = this.$refs.paymentListDialogRef;
      dom.toggle(true);
      let yAndM = {
        year: this.table.params.create_year,
        month: this.table.params.create_month,
      };
      dom.getDetail(yAndM);
      dom = null;
    },
    toPartReceived(row) {
      let identify = getStorage("identify");
      if (identify != 3) {
        this.$message.error("抱歉，该账号不是出纳人员");
        return;
      }
      let dom = this.$refs.partReceivedDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
    },
    toreceivedAmount(val, row) {
      let identify = getStorage("identify");
      if (identify != 3) {
        this.$message.error("抱歉，该账号不是出纳人员");
        return;
      }
      if (val == "part") {
        let dom = this.$refs.partReceivedDialogRef;
        dom.toggle(true);
        dom.getDetail(row);
      } else if (val == "all") {
        let str = `${row.company_name}${row.year}-${row.month}工资款项确认全额回款吗？`;
        this.$confirm(str, "全额回款", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          center: true,
          type: "warning",
        }).then(() => {
          this.allReceivedAmount(row);
        });
      }
    },
    allReceivedAmount(row) {
      let params = {
        id: row.id,
      };
      this.$http.post("/admin/finance/received", params).then((res) => {
        if (res.code === 1) {
          this.$message.success("操作成功！");
          this.getTable();
        }
      });
    },
    topayment(row) {
      let identify = getStorage("identify");
      if (identify != 3) {
        this.$message.error("抱歉，该账号不是出纳人员");
        return;
      }
      let params = {
        id: row.id,
      };
      this.$http.post("/admin/finance/payment", params).then((res) => {
        if (res.code === 1) {
          this.$message.success("操作成功！");
          this.getTable();
        }
      });
    },
    failRow(row) {
      let identify = getStorage("identify");
      if (identify != 3) {
        this.$message.error("抱歉，该账号不是出纳人员");
        return;
      }
      let dom = this.$refs.UntreadList;
      dom.toggle(true);
      dom.getDetail(row, 2);
      dom = null;
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-wrap {
  text-align: center;
  p {
    margin: 20 auto;
  }
  .company-name {
    margin-bottom: 20px;
  }
}
.el-date-editor.el-input {
  width: 220px !important;
}
.el-form--inline .el-form-item {
  margin-bottom: 18px !important;
}
.monthV {
  margin-left: 16px;
  cursor: pointer;
  font-weight: bold;
  color: #595959;
}
.acColor {
  color: #409eff;
}
</style>